var map = {
	"./flavor1.svg": "b6ae",
	"./flavor10.svg": "95f1",
	"./flavor11.svg": "cbc3",
	"./flavor12.svg": "e2d3",
	"./flavor2.svg": "6b0a",
	"./flavor3.svg": "ae33",
	"./flavor4.svg": "7bd9",
	"./flavor5.svg": "81e7",
	"./flavor6.svg": "2263",
	"./flavor7.svg": "2de6",
	"./flavor8.svg": "90ef",
	"./flavor9.svg": "60d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b28f";